function PreviewTable({ columns, rows, ui }) {
  const previewRows = rows.slice(0, 5);

  return (
    <div
      className="border overflow-x-auto mb-4"
      style={{ borderColor: ui.border }}
    >
      <table className="w-full text-xs">
        <thead>
          <tr
            className="border-b"
            style={{ borderBottomColor: ui.border, backgroundColor: ui.bgSecondary }}
          >
            {columns.map((col) => (
              <th
                key={col.name}
                className="px-2 py-1 text-left font-medium border-r last:border-r-0"
                style={{ borderRightColor: ui.borderSecondary, color: ui.text }}
              >
                <div className="mb-1 truncate" title={col.name}>
                  {col.name}
                  <span className="ml-1" style={{ color: ui.textSecondary }}>
                    ({col.type === 'number' ? '#' : 'abc'})
                  </span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {previewRows.map((row, i) => (
            <tr
              key={i}
              className="border-b last:border-b-0"
              style={{ borderBottomColor: ui.borderSecondary }}
            >
              {columns.map((col) => (
                <td
                  key={col.name}
                  className="px-2 py-1 truncate max-w-[120px] border-r last:border-r-0"
                  style={{ borderRightColor: ui.borderSecondary, color: ui.text }}
                >
                  {row[col.name] !== null && row[col.name] !== undefined
                    ? String(row[col.name])
                    : <span style={{ color: ui.textSecondary }}>—</span>
                  }
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PreviewTable;
